module.exports = __webpack_public_path__ + "img/islington_b3.9d134656.jpg";